module.exports = {
  __depends__: [
    require(130),
    require(161),
    require(165),
    require(173),
    require(236),
    require(20),
    require(14),
    require(16),
    require(20),
    require(82),
    require(64)
  ],
  editorActions: [ 'type', require(17) ]
};
